/**
 * Kunden & Nutzer und — für den Plattform-Root — die Plattformrollen (Fachprüfer Recht / FM)
 * unter einem Eintrag. Der Reiter steht in der Adresse (`?tab=platformRoles`), damit er
 * verlinkbar ist und „Zurück“ funktioniert.
 */

import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import CustomerAndUserManagementPanel from "./CustomerAndUserManagementPanel";
import PlatformRolesPanel from "./PlatformRolesPanel";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

const TAB_PARAM = "tab";

export default function UserAndRoleManagementPanel(properties: { showPlatformRoles: boolean; initialTab?: string }) {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();

  if (!properties.showPlatformRoles) {
    return <CustomerAndUserManagementPanel />;
  }

  const requested = searchParams.get(TAB_PARAM) || properties.initialTab;
  const tab = requested === "platformRoles" ? "platformRoles" : "customers";

  const changeTab = (value: string) =>
    setSearchParams(
      (current) => {
        const next = new URLSearchParams(current);
        next.set(TAB_PARAM, value);
        return next;
      },
      { replace: false },
    );

  return (
    <Tabs value={tab} onValueChange={changeTab} className="min-w-0">
      <TabsList>
        <TabsTrigger value="customers">{t("administrationPage.customerManagement")}</TabsTrigger>
        <TabsTrigger value="platformRoles">{t("administrationPage.platformRoles")}</TabsTrigger>
      </TabsList>
      <TabsContent value="customers">
        <CustomerAndUserManagementPanel />
      </TabsContent>
      <TabsContent value="platformRoles">
        <PlatformRolesPanel />
      </TabsContent>
    </Tabs>
  );
}
